var app = angular.module("leonardo");

var EditAccountDialogController = function($scope, CountryService, FormErrorsService, PermissionService,
                                           AuthDataService, ClientInstanceService, NotificationService, ChargeCodeService, SectorRestService, LanguageService, AccountService, ngDialog) {
  $scope.account = angular.copy($scope.ngDialogData.account);
  if(!isEmpty($scope.account.account_client_instance_mappings)) {
    $scope.account['white_label_status'] = $scope.account.account_client_instance_mappings.status && $scope.account.account_client_instance_mappings.skinning_level;
    $scope.account['client_instance'] = $scope.account.account_client_instance_mappings.client_instance;
  }
  $scope.clientinstance = angular.copy($scope.ngDialogData.clientinstance);
  $scope.whitelabel = angular.copy($scope.ngDialogData.whitelabel);
  $scope.account['account_client_instance_white_label_mapping'] =  $scope.whitelabel ? {...$scope.whitelabel} : {};
  $scope.permissionService = PermissionService;
  $scope.authDataService = AuthDataService;
  $scope.authDataService = AuthDataService;
  $scope.ClientInstanceService = ClientInstanceService;
  $scope.sectorRestService = SectorRestService;
  $scope.data = angular.copy($scope.ngDialogData.account);
  $scope.fromSkinOption = false;

  function filterLogos(params) {
    return {
      ...params,
      white_label: {
        ...params.white_label,
        principal_logo: params?.white_label?.principal_logo?.startsWith('filename:') ? 'data:' + params?.white_label?.principal_logo?.split(':data:')[1] : params?.white_label?.principal_logo,
        public_logo: params?.white_label?.public_logo?.startsWith('filename:') ? 'data:' + params?.white_label?.public_logo?.split(':data:')[1] : params?.white_label?.public_logo,
        favicon_logo: params?.white_label?.favicon_logo?.startsWith('filename:') ? 'data:' + params?.white_label?.favicon_logo?.split(':data:')[1] : params?.white_label?.favicon_logo,
        mobile_in_app_logo: params?.white_label?.mobile_in_app_logo?.startsWith('filename:') ? 'data:' + params?.white_label?.mobile_in_app_logo?.split(':data:')[1] : params?.white_label?.mobile_in_app_logo,
        mobile_app_skin_logo: params?.white_label?.mobile_app_skin_logo?.startsWith('filename:') ? 'data:' + params?.white_label?.mobile_app_skin_logo?.split(':data:')[1] : params?.white_label?.mobile_app_skin_logo
      }
    }
  };

  $scope.showSkinningOption = function (isWhiteLabelEnabled) {
    if (isWhiteLabelEnabled) {
      ngDialog.openConfirm({
        template: 'views/templates/admin/account/dialog/skinning-options.html',
        className: 'ngdialog-theme-default ngdialog-white-label-edit',
        controller: 'EditSkinningOptionController',
        data: {
          clientInstance: $scope.clientinstance || $scope.defaultclientinstance,
          whitelabelData: $scope.fromSkinOption ? $scope.updateWhitelabel($scope.whitelabel, $scope.updatedwhitelabel) : $scope.whitelabel
        }
      }).then(function (data) {
        if (data) {
          data.white_label['skinning_level'] = 1; // 1: Account has overwritten the skining options of Client Instance
          data.white_label['name'] = data.name;
          if (data.white_label) {
            let filterSkinData = filterLogos(data);
            $scope.updatedwhitelabel = filterSkinData;
            $scope.fromSkinOption = true;
            $scope.account['account_client_instance_white_label_mapping'] = filterSkinData.white_label;
          }
        }
      });
    }
  };

  $scope.updateWhitelabel = function (olddata, newdata) {
    olddata.name = newdata.name;
    olddata.api_url = newdata.white_label.api_url;
    olddata.aux_color = newdata.white_label.aux_color;
    olddata.company_help_email = newdata.white_label.company_help_email;
    olddata.default_email = newdata.white_label.default_email;
    olddata.error_color = newdata.white_label.error_color;
    olddata.favicon_logo = newdata.white_label.favicon_logo;
    olddata.media_url = newdata.white_label.media_url;
    olddata.mobile_app_skin_logo = newdata.white_label.mobile_app_skin_logo;
    olddata.mobile_in_app_logo = newdata.white_label.mobile_in_app_logo;
    olddata.name = newdata.white_label.name,
    olddata.primary_color = newdata.white_label.primary_color;
    olddata.principal_logo = newdata.white_label.principal_logo;
    olddata.public_logo = newdata.white_label.public_logo;
    olddata.secondary_color = newdata.white_label.secondary_color;
    olddata.skinning_level = 1;
    olddata.success_color = newdata.white_label.success_color;
    olddata.tertiary_color = newdata.white_label.tertiary_color;
    olddata.warning_color = newdata.white_label.warning_color;
    olddata.web_url = newdata.white_label.web_url
    return olddata;
  }

  if ($scope.account.country) {
    $scope.account.country = $scope.account.country.id;
  }

  if($scope.data.country && ($scope.data.country.code || '').toLowerCase() === 'ca'){
    $scope.data.currency_code = 'CAD';
  }

  $scope.countryService = CountryService;
  $scope.languageService = LanguageService;

  if($scope.account.languages && $scope.account.languages.length > 0){
    $scope.account.languages = $scope.account.languages.map(lang => lang.id)
  }

  if (!$scope.account.permissions) {
    $scope.account.permissions = {};
  }

  $scope.account.chargeCodes = [];

  ChargeCodeService.getlist({account: $scope.account.id, summary:true}).then(function(data) {
    $scope.chargeCodes = data;
  });

  function getAllClientInstance(){
    ClientInstanceService.getlist({essential: true}).then(function(data) {
      $scope.clientinstances = data;
      if($scope.clientinstances.length > 0){
        $scope.defaultclientinstance  = $scope.clientinstances.find(CI => CI.name === 'Leonardo247');
        $scope.clientinstances = $scope.clientinstances.map(CI => {
          CI.name = `${CI.name} (id:${CI.id})`;
          return CI;
        });
      }
    });
  }
  getAllClientInstance();

  angular.forEach(PermissionService.permissionsAccount, function(permission) {
    $scope.account.permissions[permission] = $scope.account.permissions[permission] || false;
  });

  $scope.editChargeCode = function(charge, amount) {
    if(typeof amount === "number"){
      charge.edit({default_amount: amount});
    }
  };

  $scope.getPermissionKeys = function(group) {
    var keys = [];
    angular.forEach(PermissionService.permissionsAccount, function (key) {
      if (_.contains(key, 'permission_') && !_.contains(key, '_all_') &&  _.contains(key, group)) {
        keys.push(key);
      }
    });
    return keys;
  };

  $scope.getClassPermissionsAll = function (group) {
    if (!$scope.account) {
      return '';
    }
    if (group == 'all') {
      $scope.account.permissions.permission_all = true;
      angular.forEach(PermissionService.permissionsAccount, function (permission) {
        if (AuthDataService.authData.whiteLabel && AuthDataService.authData.whiteLabel.default_account_permissions[permission]) {
          if (!$scope.account.permissions[permission]) {
            $scope.account.permissions.permission_all = false;
          }
        }
        else if (!AuthDataService.authData.whiteLabel) {
          if ($scope.account.client_instance) {
            if ($scope.clientinstance && $scope.clientinstance.default_account_permissions[permission]) {
              if (!$scope.account.permissions[permission]) {
                $scope.account.permissions.permission_all = false;
              }
            }
          }
          else {
            if (!$scope.account.permissions[permission]) {
              $scope.account.permissions.permission_all = false;
            }
          }
        }
      });
      if ($scope.account.permissions.permission_all) {
        return 'active';
      }
      else {
        return '';
      }
    }
    else {
      var keys = $scope.getPermissionKeys(group);
      var active = true;
      angular.forEach(keys, function (key) {
        if (!$scope.account.permissions[key]) {
          active = false;
        }
      });
      if (active) {
        $scope.account.permissions['permission_all_' + group] = true;
        return 'active';
      }
      else {
        $scope.account.permissions['permission_all_' + group] = false;
        return '';
      }
    }
  };

  $scope.selectAllPermissions = function (group) {
    if (!$scope.account) {
      return;
    }
    if (group == 'all') {
      if (!$scope.account.permissions.permission_all) {
        angular.forEach(PermissionService.permissionsAccount, function (permission) {
          if (AuthDataService.authData.whiteLabel && AuthDataService.authData.whiteLabel.default_account_permissions[permission]) {
            $scope.account.permissions[permission] = true;
          }
          else if (!AuthDataService.authData.whiteLabel) {
            if ($scope.account.client_instance) {
              if ($scope.clientinstance.default_account_permissions[permission]) {
                $scope.account.permissions[permission] = true;
              }
            }
            else {
              $scope.account.permissions[permission] = true;
            }
          }
        });
      }
      else {
        angular.forEach(PermissionService.permissionsAccount, function (permission) {
          $scope.account.permissions[permission] = false;
        });
      }
      $scope.account.permissions.permission_all = !$scope.account.permissions.permission_all;
    }
    else {
      var keys = $scope.getPermissionKeys(group);
      if (!$scope.account.permissions['permission_all_' + group]) {
        angular.forEach(keys, function (key) {
          $scope.account.permissions[key] = true;
        });
      }
      else {
        angular.forEach(keys, function (key) {
          $scope.account.permissions[key] = false;
        });
      }
    }
  };

  $scope.ifAccountPermissions = function (group) {
    if ($scope.account.client_instance) {
      return filterClientInstanceDefaultPermission(group);
    }
    else {
      if (AuthDataService.isAdmin()) return true;
      var keys = $scope.getPermissionKeys(group);
      var active = false;
      angular.forEach(keys, function (key) {
        if (AuthDataService.authData.whiteLabel.default_account_permissions[key]) {
          active = true;
        }
      });
      return active;
    }
  };

  function filterClientInstanceDefaultPermission(group) {
    var keys = $scope.getPermissionKeys(group);
    var active = false;
    angular.forEach(keys, function (key) {
      if ($scope.clientinstance && $scope.clientinstance.default_account_permissions[key]) {
        active = true;
      }
    });
    return active;
  }

  $scope.$watch('account.permission.permission_login_with_sso', function (newValue, oldValue) {
    if (!angular.equals(newValue,oldValue)){
      if (!newValue){
        $scope.account.permissions.permission_sso_get_properties_from_idp = false;
        $scope.account.permissions.permission_sso_get_role_from_idp = false;
      }
    }
  });

  $scope.submit = function() {
    $scope.Form.$submitted = true;
    if ($scope.Form.$invalid) {
      FormErrorsService.goToError();
      return;
    }
    if ($scope.account.permissions?.permission_view_help_section) {
      $scope.account.permissions.permission_view_help_section = false;
    }
    if($scope.account.languages){
      $scope.account.languages = (!angular.isArray($scope.account.languages)) ? $scope.account.languages.split(',').map(Number) :  $scope.account.languages;
    }
    else {
      $scope.account.languages = [];
    }

    if(!$scope.account.white_label_status && !isEmpty($scope.account.account_client_instance_white_label_mapping)) {
      $scope.account.account_client_instance_white_label_mapping['skinning_level'] = 0;
    }
    const data = angular.copy($scope.account);
    $scope.account.patch(data).then(function(result) {
      const old_permission = $scope.ngDialogData.account.permissions.permission_view_code_templates_tasks;
      const new_permission = result.permissions.permission_view_code_templates_tasks;
      if (old_permission !== new_permission) {
        NotificationService.notify('warning', 'These changes may take a while. \n If the changes in the account are not reflected within a maximum of 30min, contact the Admin.')
      }
      $scope.confirm(result);
    });
  };

  // for saving the languages only
  $scope.saveLanguages = function() {
    var selected_languages;
    if(!$scope.account.languages){
      selected_languages = [];
    }
    else {
      selected_languages = (!angular.isArray($scope.account.languages)) ? $scope.account.languages.split(',').map(Number) :  $scope.account.languages
    }
    let data = {
      selected_languages : selected_languages
    }
    AccountService.updateLanguages($scope.account, data);
  }
};

app.controller('EditAccountDialogController', ['$scope', 'CountryService', 'FormErrorsService', 'PermissionService',
  'AuthDataService', 'ClientInstanceService', 'NotificationService', 'ChargeCodeService', 'SectorRestService', 'LanguageService', 'AccountService', 'ngDialog', EditAccountDialogController]);
